// extracted by mini-css-extract-plugin
export default {"opacity-zero":"opacity-zero","progressBarContainer":"progressBarContainer","ant-space-item":"ant-space-item","ant-space":"ant-space","ant-progress-bg":"ant-progress-bg","loading-animation-wrapper":"loading-animation-wrapper","progressBarModal":"progressBarModal","ant-modal-body":"ant-modal-body"};
    if(module.hot) {
      // 1793340204708
      var cssReload = require("/home/vsts/work/1/s/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  